import React, { useContext } from "react";
import dukImage from "sass/images/duk.jpg";

// External components
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";

// Contexts
import { DataContext } from "contexts/Data";
const Duk = () => {
    const { language, data } = useContext(DataContext);
    // const URL = dukImage;
    // const color = "rgba(255,255,255,0.5)";
    // const MAP = {
    //     name: "my-map",
    //     areas: [
    //         {
    //             name: "bottom",
    //             shape: "rect",
    //             coords: [1192, 1816, 768, 1747], // X, Y, W, H
    //             preFillColor: color,
    //         },
    //         {
    //             name: "bottom left",
    //             shape: "rect",
    //             coords: [4, 1713, 210, 1833], // X, Y, W, H
    //             preFillColor: color,
    //         },
    //         {
    //             name: "bottom right",
    //             shape: "rect",
    //             coords: [1754, 1719, 1949, 1833], // X, Y, W, H
    //             preFillColor: color,
    //         },
    //     ],
    // };
    // const setModal = (src, className) => {
    //     setShowModal(true);
    //     setContent(
    //         <img
    //             width="100%"
    //             src={process.env.PUBLIC_URL + `/images/duk/${src}.jpg`}
    //             className={className}
    //             alt="duk"
    //         />
    //     );
    // };
    const options = {
        settings: { lightboxTransitionSpeed: 0, slideTransitionSpeed: 0 },
    };
    return (
        <>
            {/* <div className="duk-map">
                    <ImageMapper
                        src={URL}
                        map={MAP}
                        onClick={(area, index, event) => console.log(area)}
                    />
                </div> */}
            {/* <img src={dukImage} usemap="#image-map" /> */}

            {/* <map name="image-map" className="duk-map">
                    <area
                        target=""
                        alt="left"
                        title="left"
                        href=""
                        coords="0,779,122,1063"
                        shape="0"
                    />
                    <area
                        target=""
                        alt="right"
                        title="right"
                        href=""
                        coords="1897,774,1999,1081"
                        shape="0"
                    />
                    <area
                        target=""
                        alt="top"
                        title="top"
                        href=""
                        coords="798,1,1166,106"
                        shape="0"
                    />
                    <area
                        target=""
                        alt="top left"
                        title="top left"
                        href=""
                        coords="2,0,219,129"
                        shape="0"
                    />
                    <area
                        target=""
                        alt="top right"
                        title="top right"
                        href=""
                        coords="1709,1,1999,153"
                        shape="0"
                    />
                </map> */}
            <div className="duk">
                <div className="circles">
                    <SimpleReactLightbox>
                        <SRLWrapper options={options}>
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    `/images/duk/top-left.jpg`
                                }
                                alt={`
                                ${
                                    language === "no"
                                        ? 'Øvre venstre hjørne av duk - "Vinket i Ejæne"'
                                        : ""
                                }
                                ${
                                    language === "en"
                                        ? 'Top left of cloth - "Vinket i Ejæne"'
                                        : ""
                                }
                                `}
                                className="circle circle--top-left"
                                // onClick={() => setModal("top-left")}
                            />
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    `/images/duk/top.jpg`
                                }
                                alt={`
                                ${
                                    language === "no"
                                        ? 'Øvre midseksjon av duk - "En trøstig tro på dagen for den bruk"'
                                        : ""
                                }
                                ${
                                    language === "en"
                                        ? 'Top centre part of cloth - "En trøstig tro på dagen for den bruk"'
                                        : ""
                                }
                                `}
                                className="circle circle--top"
                                // onClick={() => setModal("top", "duk-top")}
                            />
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    `/images/duk/top-right.jpg`
                                }
                                alt={`
                                ${
                                    language === "no"
                                        ? 'Øvre høyre hjørne av duk - "Caroline Moe"'
                                        : ""
                                }
                                ${
                                    language === "en"
                                        ? 'Top right corner of cloth - "Caroline Moe"'
                                        : ""
                                }
                                `}
                                className="circle circle--top-right"
                                // onClick={() => setModal("top-right")}
                            />
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    `/images/duk/right.jpg`
                                }
                                alt={`
                                ${
                                    language === "no"
                                        ? 'Høyre del av duk - "I tunge tider tvilen aldri slukket"'
                                        : ""
                                }
                                ${
                                    language === "en"
                                        ? 'Right part of cloth - "I tunge tider tvilen aldri slukket"'
                                        : ""
                                }
                                `}
                                className="circle circle--right"
                                // onClick={() => setModal("right", "duk-right")}
                            />
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    `/images/duk/bottom-right.jpg`
                                }
                                alt={`
                                ${
                                    language === "no"
                                        ? 'Nedre høyre hjørne av duk - "8 Mai 1945"'
                                        : ""
                                }
                                ${
                                    language === "en"
                                        ? 'Bottom right part of cloth - "8 Mai 1945"'
                                        : ""
                                }
                                `}
                                className="circle circle--bottom-right"
                                // onClick={() => setModal("bottom-right")}
                            />
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    `/images/duk/bottom.jpg`
                                }
                                alt={`
                                ${
                                    language === "no"
                                        ? 'Nedre del av duk - "Mot mørke makter sting for sting er stukket"'
                                        : ""
                                }
                                ${
                                    language === "en"
                                        ? 'Bottom right part of cloth - "Mot mørke makter sting for sting er stukket"'
                                        : ""
                                }
                                `}
                                className="circle circle--bottom"
                                // onClick={() => setModal("bottom")}
                            />
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    `/images/duk/bottom-left.jpg`
                                }
                                alt={`
                                ${
                                    language === "no"
                                        ? 'Nedre venstre hjørne av duk - "9 april 1940"'
                                        : ""
                                }
                                ${
                                    language === "en"
                                        ? 'Bottom left corner of cloth - "9 april 1940"'
                                        : ""
                                }
                                `}
                                className="circle circle--bottom-left"
                                // onClick={() => setModal("bottom-left")}
                            />
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    `/images/duk/left.jpg`
                                }
                                alt={`
                                ${
                                    language === "no"
                                        ? 'Venstre del av duk - "Som eslet er til denne duk"'
                                        : ""
                                }
                                ${
                                    language === "en"
                                        ? 'Left part of cloth - "Som eslet er til denne duk"'
                                        : ""
                                }
                                `}
                                className="circle circle--left"
                                // onClick={() => setModal("left", "duk-left")}
                            />
                        </SRLWrapper>
                    </SimpleReactLightbox>
                </div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1120.99 1031.97"
                >
                    <defs>
                        <clipPath id="duk-clip">
                            <path
                                d="M2192.9,1851.3l56.7,2.4,32.4-2.4c12.5,1.69,29.28,3.67,41.4,3l14.1-1.8c33.5,5.24,65.54,3,99.3,6.6l13.5-2.1,23.4,3,16.2-1.2c15.84,2.24,33.3-.08,52.2,2.4,41.18,5.4,83.4,3.92,126,8.4l13.5-1.2,33.9,2.7,27.9-.6c5.48,1,30.77,3.09,36.9,2.1,16.67-2.71,40.74-2.53,57.3.3l15.3-2.1,11.7,2.7,36-.3.3.3,3.9,33.6v57.3q6.9,86.38,13.8,172.8l2.1,123.6,7.8,115.5L2915,2487.9l-1.8,57.9,6,84.3-2.7,82.5-7.8,71.7-.3,41.4c-2.29,17.58-3.62,37.86-6.3,54.6-51.15.08-110.48,3.43-159.6-4.2-30.75-4.78-65.46.88-94.8-2.1l-90.6.3c-36.79-3.71-95-5.86-131.4-.6-21.85,3.16-63.67.41-83.7-2.7l-39.9-.3c-44.24-6.39-95.93-1.9-142.5-2.4-30.61-.33-59.66,2.35-88.5,5.4-46,4.87-88.47,1.06-135.9,3.3l-59.7,3.3c-17.31,2.83-43.06,5.07-60.3-.3-5-61.31,16.21-120.12,15.6-182.4l3-21.3c-5.63-47.27-4.43-97.69-8.4-151.2-1.25-16.77,1.92-32.77,0-48.9l-3.6-58.5-2.4-49.2c4.36-42.71,8.12-86.25,6-130.5l.9-40.5c-4.57-31.35-5.24-69.5-6-99.9-.34-13.5,3.17-28,.6-44.4-2.94-18.71-1.56-39.78-4.8-59.4-7-42.73-9.31-88.3-8.4-132,32.86-4.28,85.32-1.41,119.1,3.6l15.3-1.5c18.86,2.3,40.53,1.95,59.7-.3l21.9,2.4c25.43-3.11,54.81-4.52,78-9l20.7.6c13.55-2.5,32.08-3.15,46.5-5.4Z"
                                transform="translate(-1807.51 -1851.3)"
                            />
                        </clipPath>
                    </defs>
                    <image
                        href={dukImage}
                        clipPath="url(#duk-clip)"
                        preserveAspectRatio="xMidYMid slice"
                        x="-0.5%"
                        y="-0.5%"
                        width="101%"
                        height="101%"
                    />
                </svg>
            </div>
            <div className="duk-text">
                {data.pages.inspirasjon.duk.title[language] && (
                    <h1
                        className="h2"
                        style={{ marginBottom: "2rem", marginTop: "3rem" }}
                    >
                        {data.pages.inspirasjon.duk.title[language]}
                    </h1>
                )}
                {data.pages.inspirasjon.duk.description[language] && (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: data.pages.inspirasjon.duk.description[
                                language
                            ],
                        }}
                    ></div>
                )}
            </div>
        </>
    );
};

export default Duk;
